import { type JSX, createElement } from 'react';

interface RenderHtmlBlockProps {
  type: string;
  className: string;
  children: string;
}

export const RenderHtmlBlock = ({ type, className, children }: RenderHtmlBlockProps): JSX.Element => {
  return createElement(type, {
    className,
    dangerouslySetInnerHTML: { __html: children }, // eslint-disable-line @typescript-eslint/naming-convention
  });
};

export const scrollIntoViewById = (id: string): void => {
  const target = document.getElementById(id);
  target?.scrollIntoView({ behavior: 'smooth', inline: 'start' });
};
